import React, {useEffect, useState} from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const initialUser = {
    product_id: JSON.parse(localStorage.getItem('productId')),
    monthly_investments_premium: 0,
    clawback_period: 0,
}

const AddUserDialog = props => {
    const [user, setUser] = useState(initialUser)
    const {addUserHandler} = props
    const [open, setOpen] = React.useState(false)
    const [addButton, setAddButton] = useState(false)

    const [switchState, setSwitchState] = React.useState({
        addMultiple: false,
    })

    const handleSwitchChange = name => event => {
        setSwitchState({ ...switchState, [name]: event.target.checked })
    }

    const resetSwitch = () => {
        setSwitchState({ addMultiple: false })
    }

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        resetSwitch()
    }

    const handleAdd = event => {
        addUserHandler(user)
        setUser(initialUser)
        switchState.addMultiple ? setOpen(true) : setOpen(false)
    }

    const handleChange = name => ({target: {value}}) => {

        setUser({...user, "product_id": JSON.parse(localStorage.getItem('productId'))})
        setUser({...user, [name]: value})
    }

    useEffect(() => {
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null && false && direct_perm === null && false) {
            setAddButton(false);
        } else if (role_based_perm.length === 0 && direct_perm.length === 0) {
            setAddButton(false);
        } else if (role_based_perm.length > 0) {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'manage products') {
                    setAddButton(true);
                }
            })
        } else if (direct_perm.length > 0) {
            direct_perm.map((perm, i) => {
                if (perm.name === 'manage products') {
                    setAddButton(true);
                }
            })
        }
    }, [])

    return (
        <div>
            {addButton && (
                <Tooltip title="Add New">
                <span className="btn btn-sm btn-primary mr-5" onClick={handleClickOpen}>
                    <i className="fa fa-plus-square"/> &nbsp;&nbsp;Add New
                </span>
                </Tooltip>
            )}

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Create Product</DialogTitle>
                <DialogContent>
                    <DialogContentText>Please fill in details</DialogContentText>

                    <TextField
                        margin="dense"
                        label="Monthly Investment Premium"
                        type="number"
                        fullWidth
                        value={user.monthly_investments_premium}
                        onChange={handleChange('monthly_investments_premium')}
                    />

                    <FormControl style={{
                        minWidth: '100%',
                    }}>
                        <InputLabel id="demo-simple-select-label">Clawback Period</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            onChange={handleChange('clawback_period')}
                        >
                            <MenuItem value={4}>4 Months</MenuItem>
                            <MenuItem value={6}>6 Months</MenuItem>
                            <MenuItem value={12}>12 Months</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Tooltip title="Add multiple">
                        <Switch
                            checked={switchState.addMultiple}
                            onChange={handleSwitchChange('addMultiple')}
                            value="addMultiple"
                            inputProps={{'aria-label': 'secondary checkbox'}}
                        />
                    </Tooltip>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAdd} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

AddUserDialog.propTypes = {
    addUserHandler: PropTypes.func.isRequired,
}

export default AddUserDialog;
